import { render, staticRenderFns } from "./B2CVietlot.vue?vue&type=template&id=ac1e9e80"
import script from "./B2CVietlot.vue?vue&type=script&lang=js"
export * from "./B2CVietlot.vue?vue&type=script&lang=js"
import style0 from "./B2CVietlot.vue?vue&type=style&index=0&id=ac1e9e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports